
export default {
  // Navigation
  nav_home: 'Início',
  nav_services: 'Conhecimento',
  nav_differentials: 'Diferenciais',
  nav_about: 'Sobre',
  nav_contact: 'Tire Dúvidas',
  nav_login: 'Login',
  nav_blog: 'Blog',
  nav_calculator: 'Calculadora',
  nav_resources: 'Recursos',
  nav_cta: 'Explorar Conteúdo',

  // Blog
  blog: {
    hero: {
      title: 'Conhecimento que Gera Valor',
      subtitle: 'Insights, guias práticos e estratégias para imigrantes e empreendedores que buscam excelência fiscal e crescimento sustentável nos Estados Unidos.'
    },
    newsletter: {
      title: 'Receba Conteúdo Exclusivo',
      description: 'Inscreva-se em nossa newsletter e receba insights, dicas fiscais e atualizações sobre compliance diretamente no seu e-mail.',
      placeholder: 'Seu melhor e-mail',
      button: 'Inscrever-se'
    },
    featured_badge: 'Destaque',
    featured_articles: 'Artigos em Destaque',
    all_articles: 'Todos os Artigos',
    articles_count: 'artigos',
    no_articles_found: 'Nenhum artigo encontrado',
    search_placeholder: 'Buscar artigos...',
    author_team: 'Equipe Valora Core'
  },

  // Calculator
  calculator: {
    title: 'Calculadora Educativa de Cenários Fiscais',
    disclaimer: 'Esta ferramenta apresenta simulações baseadas em cenários genéricos para fins educativos e não substitui análise profissional individualizada.',
    year_label: 'Ano fiscal',
    year_tooltip: 'Escolha o ano fiscal. As faixas e deduções variam por ano.',
    year_2025: '2025',
    year_2024: '2024',
    legal_notice_title: 'Base legal & avisos',
    legal_notice_text: 'IRC §1, §11, §63, §1401–§1402 (SE tax), §3101–§3111 (FICA), §199A (QBI). S‑Corp exige salário razoável para sócio‑trabalhador; distribuições sem salário podem ser reclassificadas com FICA retroativa, multas e juros.',
    form_title: 'Dados para Cálculo',
    entity_type_label: 'Tipo de Entidade',
    entity_type_tooltip: 'Como você é tributado: PF/LLC (autônomo), S‑Corp (exige salário razoável) ou C‑Corp (imposto na empresa e possível imposto em dividendos).',
    entity_pf: 'Pessoa Física / Autônomo',
    entity_llc: 'LLC (disregarded/partnership padrão)',
    entity_scorp: 'S‑Corp',
    entity_ccorp: 'C‑Corp',
    filing_status_label: 'Status de Declaração',
    filing_status_tooltip: 'Define as faixas do IRPF e o limiar de Medicare adicional conforme o status.',
    filing_single: 'Single',
    filing_mfj: 'Married Filing Jointly',
    filing_mfs: 'Married Filing Separately',
    filing_hoh: 'Head of Household',
    gross_income_label: 'Renda Bruta Anual',
    gross_income_tooltip: 'Receita total antes de despesas dedutíveis. Para PF: renda de autônomo. Para empresa: receita total.',
    expenses_label: 'Despesas Dedutíveis',
    expenses_tooltip: 'Despesas relacionadas ao negócio que reduzem a renda tributável.',
    other_w2_label: 'Outras Rendas W-2',
    other_w2_tooltip: 'Salário de emprego CLT ou outras fontes W-2. Afeta limites de Social Security.',
    reasonable_salary_label: 'Salário Razoável',
    reasonable_salary_tooltip: 'Para S-Corp e C-Corp: salário mínimo justo para sócio-trabalhador. IRS exige que seja "razoável" para a função.',
    payout_ratio_label: 'Proporção de Distribuição',
    payout_ratio_tooltip: 'Percentual do lucro após impostos corporativos distribuído como dividendos.',
    qualified_dividends_label: 'Dividendos Qualificados',
    qualified_dividends_tooltip: 'Dividendos qualificados têm tributação preferencial (0%, 15% ou 20%).',
    apply_qbi_label: 'Aplicar Dedução QBI',
    apply_qbi_tooltip: 'Section 199A permite até 20% de dedução em rendas de negócios qualificados.',
    results_title: 'Resultados',
    income_tax: 'Imposto de Renda',
    se_tax: 'Self-Employment Tax',
    payroll_taxes: 'Payroll Taxes',
    corp_tax: 'Imposto Corporativo',
    shareholder_div_tax: 'Imposto s/ Dividendos',
    qbi_deduction: 'Dedução QBI',
    total_tax: 'Total de Impostos',
    effective_rate: 'Taxa Efetiva',
    net_income: 'Renda Líquida',
    waiting_calculation: 'Aguardando dados para cálculo automático...',
    additional_note: 'S‑Corp exige salário razoável para sócio-trabalhador. LLC padrão tributa como PF/partnership. C‑Corp tem dupla tributação (empresa e dividendos).'
  },

  // Resources
  resources: {
    items: {
      itin_guide: {
        title: 'Guia Completo ITIN 2024',
        description: 'Passo a passo detalhado para obter seu ITIN, documentos necessários e prazos.'
      },
      llc_checklist: {
        title: 'Checklist Abertura de LLC',
        description: 'Lista completa de documentos e etapas para abrir sua LLC nos EUA.'
      }
    }
  },

  // Hero section
  hero_badge: "Orlando, FL • Atendimento Nacional",
  hero_title: "Educação Fiscal para Imigrantes nos EUA",
  hero_subtitle: "Conteúdo técnico, prático e em português sobre impostos, compliance e estruturas empresariais nos Estados Unidos.",
  hero_description: "A Valora Core atua, nesta fase, com foco exclusivo em educação técnica e clareza informacional.",
  hero_cta_primary: "Explorar Conteúdo",
  hero_cta_secondary: "Assinar Newsletter",
  
  // Services section
  services_badge: "CONTEÚDO EDUCATIVO",
  services_title: "Aprenda Sobre Tributação Americana",
  services_subtitle: "Conteúdo didático para dominar impostos, compliance e estruturas empresariais nos Estados Unidos",
  services_read_more: "Ler conteúdo completo",
  
  service_tax_title: "Impostos PF/PJ",
  service_tax_subtitle: "Aprenda sobre declaração de impostos PF/PJ nos EUA. Conheça formulários, prazos e estratégias.",
  service_tax_1: "Entenda o Form 1040 / 1040-NR",
  service_tax_2: "Conheça tributação de Partnership (1065)",
  service_tax_3: "Aprenda sobre S-Corporation (1120-S)",
  service_tax_4: "Compreenda C-Corporation (1120)",
  service_tax_5: "Como revisar declarações anteriores",
  service_tax_6: "Princípios de planejamento tributário",
  service_tax_7: "Entenda o que é QBI Deduction (IRC §199A)",
  
  service_company_title: "Abertura de Empresa",
  service_company_subtitle: "Compreenda estruturas empresariais e aprenda a tomar decisões informadas sobre seu negócio.",
  service_company_1: "Diferenças entre LLC, C-Corp e S-Corp",
  service_company_2: "Entenda Operating Agreements",
  service_company_3: "Conheça EIN e BOI Report (FinCEN)",
  service_company_4: "Aprenda enquadramento fiscal",
  service_company_5: "Compreenda planejamento tributário",
  service_company_6: "Princípios de compliance empresarial",
  
  service_itin_title: "ITIN",
  service_itin_subtitle: "Entenda o processo de obtenção do ITIN e seus requisitos legais nos EUA.",
  service_itin_1: "Compreenda o processo ITIN completo",
  service_itin_2: "Aprenda sobre renovação de ITIN",
  service_itin_3: "Conheça o papel dos CAA",
  service_itin_4: "Entenda prazos e acompanhamento",
  service_itin_5: "Documentação necessária e requisitos",
  service_itin_6: "Certified Acceptance Agent (CAA)",
  
  service_compliance_title: "Compliance",
  service_compliance_subtitle: "Aprenda sobre obrigações legais e mantenha sua empresa sempre em conformidade.",
  service_compliance_1: "Entenda relatórios anuais estaduais",
  service_compliance_2: "Compreenda BOI Report (FinCEN)",
  service_compliance_3: "Aprenda sobre calendário de obrigações",
  service_compliance_4: "Princípios de monitoramento contínuo",
  service_compliance_5: "Conheça conformidade IRS e FinCEN",
  service_compliance_6: "Como prevenir multas e penalidades",
  
  service_accounting_title: "Gestão Financeira Empresarial",
  service_accounting_subtitle: "Aprenda sobre organização contábil e controle financeiro para pequenas empresas.",
  service_accounting_1: "Princípios de reconciliação bancária",
  service_accounting_2: "Categorização de transações",
  service_accounting_3: "Entendendo relatórios gerenciais",
  service_accounting_4: "Como criar calendário fiscal eficiente",
  service_accounting_5: "Técnicas de categorização fiscal",
  service_accounting_6: "Interpretação de relatórios financeiros",

  service_credits_title: "Créditos e Deduções Fiscais (PF)",
  service_credits_subtitle: "Aprenda a identificar créditos e deduções permitidos por lei e entenda como eles impactam diretamente o imposto devido ou o reembolso.",
  service_credits_1: "Diferença entre deduções, créditos não reembolsáveis e créditos reembolsáveis",
  service_credits_2: "EITC - Earned Income Tax Credit (funcionamento e elegibilidade)",
  service_credits_3: "Child Tax Credit (CTC) e Additional Child Tax Credit",
  service_credits_4: "Credit for Other Dependents (conceitos e aplicação)",
  service_credits_5: "Deduções padrão vs. itemized deductions (quando usar cada uma)",
  service_credits_6: "Despesas médicas, educacionais e de trabalho (quando aplicável)",
  service_credits_7: "Princípios de elegibilidade, limites de renda e erros comuns",
  service_credits_8: "Como evitar rejeições, auditorias e ajustes do IRS",

  lang_portuguese: "Português",
  lang_spanish: "Español",
  lang_english: "English",

  // Important Info section
  info_badge: "INFORMAÇÕES IMPORTANTES",
  info_title: "Fique por dentro dos seus direitos e obrigações",
  info_subtitle: "Informações essenciais para brasileiros nos EUA",
  info_card_1_title: "Deixou o Brasil? Faça sua Saída Fiscal e evite problemas com a Receita Federal.",
  info_card_1_description: "Se você mudou para os EUA e ainda declara imposto no Brasil, pode estar pagando mais do que deveria. Saiba como regularizar sua situação e evitar multas.",
  info_card_2_title: "Se você é estudante nos EUA, o Form 8843 é obrigatório!",
  info_card_2_description: "Mesmo sem renda, estudantes F-1, F-2, J-1 e M-1 devem enviar o Form 8843 ao IRS todos os anos. Ignorar esse documento pode afetar seu status no futuro.",
  info_card_3_title: "Precisa declarar impostos, mas não tem SSN? Você precisa do ITIN.",
  info_card_3_description: "O ITIN é o número fiscal do IRS para quem não tem Social Security. Com ele, você pode declarar impostos, abrir conta bancária e construir histórico financeiro nos EUA.",

  // Client Portal
  client_dashboard: "Visão Geral",
  client_documents: "Documentos",
  client_messages: "Mensagens",
  client_invoices: "Faturas",
  client_welcome: "Bem-vindo de volta",
  client_services_status: "Status dos Serviços",
  client_pending_documents: "Documentos Pendentes",
  client_upcoming_deadlines: "Próximos Prazos",
  client_recent_activity: "Atividade Recente",
  client_upload_document: "Enviar Documento",
  client_view_all: "Ver Todos",
  client_send_message: "Enviar Mensagem",
  client_new_message: "Nova Mensagem",
  client_pay_now: "Pagar Agora",
  client_download: "Baixar",
  client_status_in_progress: "Em Andamento",
  client_status_completed: "Concluído",
  client_status_pending: "Pendente",
  client_logout: 'Sair',
  client_collapse_menu: 'Recolher menu',
  client_expand_menu: 'Expandir menu',

  // About section
  about_badge: "QUEM SOMOS",
  about_title: "Somos especialistas em consultoria tributária para imigrantes",
  about_intro: "A Valora Core oferece educação técnica e conteúdo especializado sobre impostos e compliance para imigrantes, com sede em Orlando (FL) e atuação em todo os Estados Unidos.",
  about_description_1: "Acompanhamos você desde a concepção até a legalização do seu negócio, com orientação completa — do básico à estrutura fiscal e regulatória.",
  about_description_2: "Nosso compromisso é reduzir a assimetria de informação fiscal e regulatória enfrentada por imigrantes nos EUA, fornecendo conteúdo preciso, analítico e pedagógico em português.",
  about_mission_intro: "Nossa missão é simples:",
  about_mission: "levar clareza, segurança e excelência estratégica para quem deseja crescer e prosperar nos Estados Unidos.",
  about_certification_title: "Especialista em Consultoria Tributária para Imigrantes",
  about_certification_desc: "Certificado e registrado para atender clientes em todos os estados americanos",
  about_languages_title: "3 Idiomas",
  about_languages_list: "PT • ES • EN",
  
  // Stats
  about_stat_clients_number: "500+",
  about_stat_clients_label: "Clientes Atendidos",
  about_stat_satisfaction_number: "98%",
  about_stat_satisfaction_label: "Satisfação",
  about_stat_experience_number: "5+",
  about_stat_experience_label: "Anos de Experiência",
  about_stat_support_number: "24/7",
  about_stat_support_label: "Suporte",
  
  // Client types
  about_clients_title: "Nossos Clientes",
  about_clients_subtitle: "Atendemos diferentes perfis com soluções personalizadas para cada necessidade",
  
  about_client_immigrants_title: "Imigrantes",
  about_client_immigrants_subtitle: "Tranquilidade fiscal para quem recomeçou nos EUA.",
  about_client_immigrants_description: "Suporte completo em português e espanhol para regularização fiscal e crescimento.",
  
  about_client_freelancers_title: "Autônomos",
  about_client_freelancers_subtitle: "Simplificamos sua preparação de impostos para você focar em crescer.",
  about_client_freelancers_description: "Declarações, ITIN, planejamento tributário e estruturação empresarial personalizada.",
  
  about_client_small_business_title: "Pequenas Empresas",
  about_client_small_business_subtitle: "Da abertura à expansão, cuidamos de toda a estrutura.",
  about_client_small_business_description: "LLC, S-Corp, C-Corp, compliance, educação contábil mensal e orientação estratégica.",
  
  about_client_entrepreneurs_title: "Novos Empreendedores",
  about_client_entrepreneurs_subtitle: "Abra sua empresa do jeito certo, sem complicações.",
  about_client_entrepreneurs_description: "Orientação completa desde a estruturação até o primeiro ano de operação.",

  // Footer section
  footer_description: "Educação fiscal e tributária especializada para brasileiros nos EUA.",
  footer_services_title: "Recursos Educativos",
  footer_company_title: "Empresa",
  footer_contact_title: "Tire Dúvidas",
  footer_about_us: "Sobre Nós",
  footer_differentials: "Diferenciais",
  footer_contact: "Contato",
  footer_blog: "Blog",
  footer_location: "Orlando, FL\nEstados Unidos",
  footer_copyright: `© ${new Date().getFullYear()} Valora Core. Todos os direitos reservados.`,
  footer_privacy_policy: "Política de Privacidade",
  footer_terms_of_use: "Termos de Uso",
  footer_powered_by: "Powered by Conexdev Solutions",

  // Differentials section
  differentials_badge: "NOSSA ABORDAGEM",
  differentials_title: "Por que aprender com a Valora Core?",
  differentials_subtitle: "Mais que conteúdo tributário, ensinamos estratégias práticas para imigrantes dominarem suas finanças nos EUA",
  
  differential_compliance_title: "Educação Preventiva",
  differential_compliance_description: "Ensinamos a fazer certo desde o primeiro dia.",
  differential_compliance_details: "Nosso foco é ensinar como prevenir problemas fiscais antes que aconteçam, capacitando você para navegar com confiança no sistema americano.",
  
  differential_communication_title: "Didática e Clareza",
  differential_communication_description: "Ensinamos no seu idioma — literalmente.",
  differential_communication_details: "Explicamos cada conceito com clareza, sem termos complicados, para que você aprenda e domine o processo.",
  
  differential_specialization_title: "Especialização em Imigrantes",
  differential_specialization_description: "Entendemos os desafios de começar do zero.",
  differential_specialization_details: "Ensinamos sobre toda a estrutura fiscal e contábil americana, considerando documentação, prazos e desafios específicos de quem vive fora do Brasil.",
  
  differential_digital_title: "Aprendizado Prático",
  differential_digital_description: "Conteúdo acessível de qualquer lugar dos EUA.",
  differential_digital_details: "Combinação de conteúdo digital e exemplos práticos, do jeito que o brasileiro precisa para dominar a tributação americana.",

  // FAQ section
  faq_title: "Perguntas Frequentes",
  faq_subtitle: "Esclareça suas dúvidas sobre tributação americana. Não encontrou a resposta? Envie sua pergunta!",
  faq_cta_title: "Precisa de mais informações?",
  faq_cta_subtitle: "Explore nosso conteúdo educativo ou envie sua pergunta específica sobre tributação!",
  faq_cta_speak: "Explorar Conteúdo",
  faq_cta_email: "Enviar E-mail",

  // FAQ ITIN
  faq_itin_category: "ITIN",
  faq_itin_q1: "O que é ITIN e quem precisa?",
  faq_itin_a1: "ITIN (Individual Taxpayer Identification Number) é um número de identificação fiscal emitido pelo IRS para pessoas que precisam declarar impostos nos EUA mas não são elegíveis para SSN. É necessário para não-residentes com renda nos EUA, dependentes de cidadãos/residentes, e cônjuges de americanos.",
  faq_itin_q2: "Quanto tempo demora para obter o ITIN?",
  faq_itin_a2: "O processo completo leva entre 7 a 11 semanas após o IRS receber sua aplicação. Com a Valora Core, preparamos toda documentação em 3-5 dias úteis e acompanhamos todo o processo até a aprovação.",
  faq_itin_q3: "Quais documentos são necessários?",
  faq_itin_a3: "Você precisará de: passaporte válido (original ou cópia certificada), formulário W-7 preenchido, declaração de imposto de renda (se aplicável), e documentos que comprovem a necessidade do ITIN. Nossa equipe orienta você em cada etapa.",

  // FAQ Business Formation
  faq_business_category: "Abertura de Empresa",
  faq_business_q1: "LLC, C-Corp ou S-Corp: qual escolher?",
  faq_business_a1: "A LLC é prática e protege seus bens pessoais. A S-Corp ajuda a pagar menos impostos quando o lucro cresce.A C-Corp dá força e credibilidade para quem quer crescer grande. Fazemos análise gratuita do seu caso para recomendar a melhor estrutura.",
  faq_business_q2: "Quanto custa abrir uma LLC?",
  faq_business_a2: "Os custos variam por estado. Na Flórida, por exemplo, a taxa estadual é $125 + nossos honorários de $499 (pacote completo incluindo EIN, Operating Agreement, e consultoria). Oferecemos pacotes personalizados para cada necessidade.",
  faq_business_q3: "Posso abrir empresa sem SSN?",
  faq_business_a3: "Sim! Você pode abrir LLC/S-Corp usando ITIN ou até mesmo sem número fiscal inicialmente. Ajudamos não-residentes e estrangeiros a estruturar empresas nos EUA de forma 100% legal e em conformidade.",

  // FAQ additional categories
  faq_taxes_category: "Impostos",
  faq_taxes_q1: "Quais são os prazos fiscais importantes?",
  faq_taxes_a1: "Pessoa Física (1040): 15 de abril. LLC/Partnership (1065): 15 de março. S-Corp (1120-S): 15 de março. C-Corp (1120): 15 de abril. Impostos estimados trimestrais: 15/abr, 15/jun, 15/set, 15/jan. Enviamos lembretes automáticos para todos os prazos.",
  faq_taxes_q2: "O que é BOI Report (FinCEN)?",
  faq_taxes_a2: "BOI (Beneficial Ownership Information) é um relatório obrigatório desde 2024 para a maioria das empresas nos EUA, informando quem são os proprietários reais. Empresas criadas antes de 2024 têm até 31/dez/2024 para reportar. Multa por não compliance: até $10.000. Fazemos todo o processo por você.",
  faq_taxes_q3: "Posso deduzir despesas do home office?",
  faq_taxes_a3: "Sim! Você pode deduzir uma porcentagem de aluguel, internet, energia e manutenção proporcional ao espaço usado exclusivamente para trabalho. Também são dedutíveis: equipamentos, software, viagens de negócios, e muito mais. Maximizamos suas deduções legalmente.",

  faq_services_category: "Serviços",
  faq_services_q1: "Vocês atendem em todo os EUA?",
  faq_services_a1: "Sim! Nosso escritório físico fica em Orlando, FL, mas atendemos clientes em todos os 50 estados através de consultas, e-mail e telefone. Oferecemos serviços completos com a mesma qualidade do atendimento presencial.",
  faq_services_q2: "Como funciona a primeira consulta gratuita?",
  faq_services_a2: "Agende uma videochamada de 30 minutos com nossos especialistas. Vamos entender sua situação, responder suas dúvidas e apresentar um plano personalizado sem compromisso. Atendemos em Português e Español.",
  faq_services_q3: "Quais formas de pagamento aceitam?",
  faq_services_a3: "Aceitamos cartões de crédito/débito (Visa, Mastercard, Amex), transferências bancárias (ACH), Zelle, PayPal e parcelamento em até 3x sem juros para serviços acima de $500. Emitimos recibos e notas fiscais para todas as transações.",

  // CTA section
  cta_title: "Transforme Conhecimento em Segurança Fiscal",
  cta_subtitle: "Aprender é o primeiro passo. Dominar tributação americana é o próximo.",
  cta_description: "Na Valora Core, cada conceito tributário se transforma em confiança para tomar decisões informadas.",
  cta_feature_1: "Conteúdo prático e aplicado",
  cta_feature_2: "Aprendizado personalizado", 
  cta_feature_3: "Conhecimento sustentável",
  cta_button: "Explorar Artigos",
  cta_footer: "Conteúdo gratuito e acessível • Sem compromisso • Disponível nacionalmente",

  // WhatsApp component
  whatsapp_number: "16897774321",
  whatsapp_comment: "Número do WhatsApp da Valora Core (substitua pelo número real)",
  whatsapp_business_title: "💼 Abrir Empresa nos EUA",
  whatsapp_business_message: "Olá! Gostaria de saber mais sobre abertura de empresa nos EUA (LLC/S-Corp).",
  whatsapp_itin_title: "🆔 Solicitar ITIN",
  whatsapp_itin_message: "Olá! Preciso de ajuda para obter meu ITIN (Individual Taxpayer Identification Number).",
  whatsapp_taxes_title: "📊 Declaração de Impostos",
  whatsapp_taxes_message: "Olá! Gostaria de informações sobre declaração de impostos nos EUA.",
  whatsapp_boi_title: "📋 BOI Report",
  whatsapp_boi_message: "Olá! Preciso de ajuda com o BOI Report (Beneficial Ownership Information).",
  whatsapp_other_title: "💬 Outro Assunto",
  whatsapp_other_message: "Olá! Gostaria de falar com um especialista da Valora Core.",
  whatsapp_button_title: "Tire Dúvidas",
  whatsapp_button_subtitle: "Escolha um assunto:",
  whatsapp_close: "Fechar",

  // Newsletter
  newsletter_title: "Newsletter Educativa",
  newsletter_description: "Receba atualizações semanais sobre compliance, impostos e planejamento tributário para imigrantes",
  newsletter_placeholder: "Seu melhor e-mail",
  newsletter_button: "Inscrever-se",
  newsletter_disclaimer: "Conteúdo gratuito. Sem spam. Cancele quando quiser.",

  // Blog categories
  categories: {
    all: 'Todos',
    impostos: 'Impostos',
    abertura_empresa: 'Abertura de Empresa',
    compliance: 'Compliance',
    planejamento_tributario: 'Planejamento Tributário',
    gestao_financeira: 'Gestão Financeira',
    empreendedorismo: 'Empreendedorismo'
  },

  // Blog post interface
  blog_post: {
    you_will_learn: 'Neste artigo você vai aprender:',
    fundamental_concepts: 'Conceitos fundamentais sobre o tema',
    practical_steps: 'Passo a passo prático e aplicável',
    expert_tips: 'Dicas de especialistas da Valora Core',
    avoid_errors: 'Como evitar erros comuns',
    why_important: 'Por Que Isso é Importante?',
    importance_description: 'Para imigrantes e empreendedores nos Estados Unidos, compreender as nuances fiscais e regulatórias é fundamental para o sucesso e crescimento sustentável do negócio. A falta de conhecimento pode resultar em penalidades, multas e oportunidades perdidas de economia fiscal.',
    valora_tip: 'Dica da Valora Core',
    tip_description: 'Sempre mantenha sua documentação organizada e atualizada. Isso facilita não apenas o cumprimento das obrigações fiscais, mas também permite identificar oportunidades de otimização tributária ao longo do ano.',
    main_points: 'Principais Pontos de Atenção',
    points_description: 'Ao lidar com questões fiscais e contábeis nos Estados Unidos, é essencial estar atento a diversos aspectos que podem impactar significativamente sua situação tributária:',
    deadlines: 'Prazos e deadlines estabelecidos pelo IRS e órgãos estaduais',
    documentation: 'Documentação necessária e requisitos específicos',
    deductions: 'Oportunidades de deduções e créditos fiscais',
    compliance_regulations: 'Compliance e adequação às regulamentações vigentes',
    how_we_help: 'Como a Valora Core Pode Ajudar',
    help_description: 'Nossa equipe de especialistas está preparada para oferecer suporte completo em todas as etapas do processo. Com atendimento em Português e Espanhol, garantimos que você compreenda totalmente cada aspecto da sua situação fiscal e tome decisões informadas para o crescimento do seu negócio.',
    need_help: 'Tem uma dúvida técnica sobre este tema?',
    schedule_consultation: 'Deixe seu comentário ou assine nossa newsletter para receber atualizações semanais de compliance.',
    contact_specialist: 'Assinar Newsletter',
    conclusion: 'Conclusão',
    conclusion_description: 'Compreender e gerenciar adequadamente suas obrigações fiscais é fundamental para o sucesso do seu negócio nos Estados Unidos. Com o suporte adequado e conhecimento especializado, você pode transformar compliance em vantagem competitiva e focar no que realmente importa: o crescimento sustentável da sua empresa.',
    tags: 'TAGS',
    share: 'COMPARTILHAR',
    related_articles: 'Artigos Relacionados'
  },

  // Consentimento de Cookies
  cookie_title: 'Utilizamos Cookies',
  cookie_description: 'Utilizamos cookies para melhorar sua experiência de navegação, fornecer conteúdo personalizado, analisar tráfego e aprimorar nossos serviços. Alguns cookies são essenciais para o funcionamento adequado do site.',
  cookie_settings: 'Configurações de Cookies',
  cookie_accept_all: 'Aceitar Todos',
  cookie_reject: 'Rejeitar Opcionais',
  cookie_reject_all: 'Rejeitar Todos',
  cookie_save_preferences: 'Salvar Preferências',
  cookie_settings_title: 'Preferências de Cookies',
  cookie_settings_description: 'Utilizamos diferentes tipos de cookies para várias finalidades. Você pode personalizar suas preferências abaixo. Note que desabilitar alguns cookies pode afetar a funcionalidade do site.',
  cookie_always_active: 'Sempre Ativo',
  
  cookie_necessary_title: 'Cookies Necessários',
  cookie_necessary_description: 'Estes cookies são essenciais para o funcionamento do site e não podem ser desabilitados. Geralmente são definidos em resposta a ações que você realiza, como preferências de idioma, login ou envio de formulários.',
  
  cookie_analytics_title: 'Cookies de Análise',
  cookie_analytics_description: 'Estes cookies nos ajudam a entender como os visitantes interagem com nosso site, coletando e reportando informações de forma anônima. Isso nos ajuda a melhorar a experiência do usuário.',
  
  cookie_marketing_title: 'Cookies de Marketing',
  cookie_marketing_description: 'Estes cookies são usados para fornecer anúncios e comunicações de marketing relevantes. Podem ser usados para construir um perfil dos seus interesses e mostrar anúncios relevantes.',
  
  cookie_functional_title: 'Cookies Funcionais',
  cookie_functional_description: 'Estes cookies habilitam funcionalidades aprimoradas e personalização, como vídeos e chats ao vivo. Podem ser definidos por nós ou por provedores terceirizados.',

  // Política de Privacidade
  privacy_policy_title: 'Política de Privacidade',
  privacy_policy_last_updated: 'Última atualização',
  privacy_policy_introduction_title: 'Introdução',
  privacy_policy_introduction_text: 'A Valora Core LLC ("nós", "nosso" ou "nos") é uma empresa de contabilidade especializada em imigrantes, com sede em Orlando, FL e operações em todos os Estados Unidos. Estamos comprometidos em proteger sua privacidade. Esta Política de Privacidade explica como coletamos, usamos, divulgamos e protegemos suas informações quando você visita nosso site e usa nossos serviços de contabilidade e impostos.',
  privacy_policy_collection_title: 'Informações que Coletamos',
  privacy_policy_personal_info: 'Informações Pessoais',
  privacy_policy_personal_info_1: 'Nome, endereço de e-mail, telefone e endereço para correspondência',
  privacy_policy_personal_info_2: 'Números de identificação fiscal (SSN, ITIN, EIN) e informações empresariais',
  privacy_policy_personal_info_3: 'Informações financeiras para preparação de impostos e serviços de formação de empresas',
  privacy_policy_personal_info_4: 'Status migratório, composição familiar e informações de dependentes para fins fiscais',
  privacy_policy_usage_data: 'Dados de Uso',
  privacy_policy_usage_data_1: 'Endereço IP, tipo de navegador e informações do dispositivo',
  privacy_policy_usage_data_2: 'Páginas visitadas, tempo gasto e padrões de interação',
  privacy_policy_usage_data_3: 'Fontes de referência e termos de pesquisa',
  privacy_policy_usage_data_4: 'Cookies e tecnologias de rastreamento similares',
  privacy_policy_cookies_title: 'Cookies e Tecnologias de Rastreamento',
  privacy_policy_cookies_description: 'Usamos cookies e tecnologias similares para melhorar sua experiência, analisar uso e fornecer conteúdo personalizado. Você pode gerenciar suas preferências de cookies através do nosso banner de consentimento.',
  privacy_policy_cookie_types: 'Tipos de Cookies que Usamos',
  privacy_policy_necessary_cookies: 'Essenciais para funcionalidade e segurança do site',
  privacy_policy_analytics_cookies: 'Nos ajudam a entender o comportamento do usuário e melhorar nossos serviços',
  privacy_policy_marketing_cookies: 'Usados para publicidade direcionada e campanhas de marketing',
  privacy_policy_functional_cookies: 'Habilitam recursos aprimorados como chat ao vivo e vídeos',
  privacy_policy_usage_title: 'Como Usamos Suas Informações',
  privacy_policy_usage_1: 'Fornecer e manter nossos serviços de contabilidade, preparação de impostos e consultoria empresarial',
  privacy_policy_usage_2: 'Processar declarações de impostos, solicitações de ITIN e documentos de formação de empresas',
  privacy_policy_usage_3: 'Comunicar com você sobre nossos serviços, prazos e atualizações regulatórias',
  privacy_policy_usage_4: 'Melhorar nosso site e serviços baseado em análises de uso e feedback de clientes',
  privacy_policy_usage_5: 'Cumprir com requisitos do IRS, FinCEN e outras obrigações regulatórias',
  privacy_policy_usage_6: 'Proteger contra fraudes e garantir a segurança da plataforma para dados financeiros sensíveis',
  privacy_policy_sharing_title: 'Compartilhamento e Divulgação de Informações',
  privacy_policy_sharing_description: 'Não vendemos, negociamos ou alugamos suas informações pessoais. Podemos compartilhar informações apenas nas seguintes circunstâncias:',
  privacy_policy_sharing_1: 'Com seu consentimento explícito ou sob sua direção',
  privacy_policy_sharing_2: 'Com provedores de serviços confiáveis que auxiliam nossas operações',
  privacy_policy_sharing_3: 'Para cumprir obrigações legais ou ordens judiciais',
  privacy_policy_sharing_4: 'Para proteger nossos direitos, propriedade ou segurança e a de nossos usuários',
  privacy_policy_security_title: 'Segurança de Dados',
  privacy_policy_security_description: 'Implementamos medidas de segurança padrão da indústria para proteger suas informações, incluindo criptografia, servidores seguros e auditorias regulares de segurança. No entanto, nenhum método de transmissão pela internet é 100% seguro.',
  privacy_policy_rights_title: 'Seus Direitos de Privacidade',
  privacy_policy_rights_1: 'Acessar e revisar suas informações pessoais',
  privacy_policy_rights_2: 'Solicitar correção de dados imprecisos ou incompletos',
  privacy_policy_rights_3: 'Solicitar exclusão de suas informações pessoais',
  privacy_policy_rights_4: 'Objetar ou restringir certas atividades de processamento',
  privacy_policy_rights_5: 'Solicitar portabilidade de dados em formato estruturado',
  privacy_policy_rights_6: 'Retirar consentimento para processamento opcional de dados',
  privacy_policy_transfers_title: 'Transferências Internacionais de Dados',
  privacy_policy_transfers_description: 'Como atendemos clientes internacionalmente, suas informações podem ser transferidas e processadas em países diferentes da sua residência. Garantimos que salvaguardas apropriadas estejam em vigor para tais transferências.',
  privacy_policy_retention_title: 'Retenção de Dados',
  privacy_policy_retention_description: 'Retemos suas informações apenas pelo tempo necessário para fornecer nossos serviços, cumprir obrigações legais ou resolver disputas. Documentos relacionados a impostos podem ser retidos por períodos estendidos conforme exigido por lei.',
  privacy_policy_contact_title: 'Entre em Contato',
  privacy_policy_contact_description: 'Se você tiver dúvidas sobre esta Política de Privacidade ou desejar exercer seus direitos de privacidade, entre em contato conosco:',
  privacy_policy_updates_title: 'Atualizações da Política',
  privacy_policy_updates_description: 'Podemos atualizar esta Política de Privacidade periodicamente. Notificaremos sobre mudanças significativas através do nosso site ou comunicação direta. Seu uso continuado dos nossos serviços constitui aceitação da política atualizada.',
  contact_email: 'E-mail',
  contact_address: 'Endereço',
  contact_phone: 'Telefone',
  all_rights_reserved: 'Todos os direitos reservados.'
};
